module.exports = __webpack_public_path__ + "media/images/icon__point--gained-0a46c4f568e2e26aab3bdcd2f2dafd77.png";